import { IChingTrigramFacts, IChingTrigramId } from './iching.models';

/** Taalonafhankelijke feiten; bits onder→boven (Wilhelm/King Wen-conventie). */
export const ICHING_TRIGRAMS: Readonly<Record<IChingTrigramId, IChingTrigramFacts>> = {
  qian: { id: 'qian', bits: '111', symbol: '☰', pinyin: 'Qián' },
  dui: { id: 'dui', bits: '110', symbol: '☱', pinyin: 'Duì' },
  li: { id: 'li', bits: '101', symbol: '☲', pinyin: 'Lí' },
  zhen: { id: 'zhen', bits: '100', symbol: '☳', pinyin: 'Zhèn' },
  xun: { id: 'xun', bits: '011', symbol: '☴', pinyin: 'Xùn' },
  kan: { id: 'kan', bits: '010', symbol: '☵', pinyin: 'Kǎn' },
  gen: { id: 'gen', bits: '001', symbol: '☶', pinyin: 'Gèn' },
  kun: { id: 'kun', bits: '000', symbol: '☷', pinyin: 'Kūn' },
};

/** Volgorde van Wilhelms sleuteltabel (rij = boven, kolom = onder). */
export const ICHING_TRIGRAM_TABLE_ORDER: readonly IChingTrigramId[] = [
  'qian',
  'zhen',
  'kan',
  'gen',
  'kun',
  'xun',
  'li',
  'dui',
];

/** King Wen-nummer per [boven][onder] in ICHING_TRIGRAM_TABLE_ORDER (geverifieerd). */
export const ICHING_HEXAGRAM_MATRIX: readonly (readonly number[])[] = [
  [1, 25, 6, 33, 12, 44, 13, 10],
  [34, 51, 40, 62, 16, 32, 55, 54],
  [5, 3, 29, 39, 8, 48, 63, 60],
  [26, 27, 4, 52, 23, 18, 22, 41],
  [11, 24, 7, 15, 2, 46, 36, 19],
  [9, 42, 59, 53, 20, 57, 37, 61],
  [14, 21, 64, 56, 35, 50, 30, 38],
  [43, 17, 47, 31, 45, 28, 49, 58],
];
